import { useNavigate, useSearch } from '@tanstack/react-router';

import { type DebugSortDirection, type DebugSortProperty } from './model';
import {
  debugRouteSearchSchema,
  parseDebugRouteSearch,
  serializeDebugRouteSearch,
} from './debugRouteSearch';

export function useDebugRouteFilters() {
  const navigate = useNavigate({ from: '/debug' });
  const search = useSearch({ strict: false });
  const filter = parseDebugRouteSearch(debugRouteSearchSchema(search));
  const update = (next: typeof filter) => {
    void navigate({ search: serializeDebugRouteSearch(next), replace: true });
  };

  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
    setSort: (sortProperty: DebugSortProperty | null, sortDirection: DebugSortDirection) => {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
  };
}
